module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "take-place contacts-container column"
  }, [_c('div', {
    staticClass: "attached-item row"
  }, [_c('div', {
    staticClass: "phantom-flex"
  }), _vm._v(" "), _c('div', {
    staticClass: "listing row"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.clients.length) + " client" + _vm._s((_vm.clients.length > 1) ? 's ' : ' ') + "\n\t\t\t")]), _vm._v(" "), (_vm.prospectInContacts > 0) ? _c('div', [_vm._v("\n\t\t\t\tdont " + _vm._s(_vm.prospectInContacts) + " prospect" + _vm._s((_vm.prospectInContacts > 1) ? 's' : '') + "\n\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.showAddContact = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-contact"
  }), _vm._v(" Ajouter un contact\n\t\t\t")])])]), _vm._v(" "), _c('ag-table', {
    attrs: {
      "rows": _vm.clients,
      "columns": _vm.cols,
      "customOptions": _vm.options,
      "addSearch": true
    }
  }), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.showAddContact,
      "content": _vm.contentModal
    },
    on: {
      "close": function($event) {
        _vm.showAddContact = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ea2d4d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/Contacts/Table.vue
// module id = 1128
// module chunks = 0